import { SupportedUtms, UTMs } from '@shared/types';

const SUPPORTED_UTMS: SupportedUtms[] = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'referrer',
    'trk',
];

export const filterApprovedUtms = (utms: { [key: string]: string }): UTMs => {
    return SUPPORTED_UTMS.reduce((acc, key) => {
        if (utms[key]) {
            return { ...acc, ...{ [key]: utms[key] } };
        }
        return acc;
    }, {});
};
